/*
 * @Author: 小周
 * @Date: 2024-06-17 10:28:35
 * @LastEditTime: 2024-07-02 15:38:51
 * @LastEditors: MrZHLF
 * @Description: 获取评论接口数据
 */
import request from '@utils/request'
let BASE_URL = process.env.REACT_APP_API_COMMENT

// 获取评论列表
export function getCommentList(params) {
  return request({
    url: BASE_URL + '/dx-bridge/get-comment-with-article-super-v2',
    method: 'get',
    params,
  })
}

/**
 *
 * @param {object} data
 * @description 添加评论以及回复
 * @returns
 */
export function addComment(data) {
  return request({
    url: BASE_URL + '/dx-bridge/save-comment',
    method: 'post',
    data,
  })
}

/**
 *
 * @param {string} objectId 文章id 或者 评论id
 * @param {string} operationType 操作行为 DZ-点赞，CS-收藏。GZ-关注
 * @param {string} objectType 对象类别,例如：PL，WZ，PK
 * @param { number } typeId 1
 * @description 评论点赞接口
 * @returns
 */
export function operationType(data) {
  return request({
    url: BASE_URL + '/dx-bridge/operation',
    method: 'post',
    data,
  })
}

/**
 *
 * @param {string} objectId 文章id 或者 评论id
 * @param {string} operationType 操作行为 DZ-点赞，CS-收藏。GZ-关注
 * @param {string} objectType 对象类别,例如：PL，WZ，PK
 * @param { number } typeId 1
 * @description 取消评论点赞接口
 * @returns
 */
export function cancelType(data) {
  return request({
    url: BASE_URL + '/dx-bridge/cancel',
    method: 'post',
    data,
  })
}

/**
 *
 * @param {string} params 文章ID
 * @description 获取某文章下总评论数
 * @returns
 */
export function getCommentTotal(id) {
  return request({
    url: BASE_URL + `/dx-bridge/total-comment-num/${id}`,
    method: 'get',
  })
}

export function getLikeTotal(id) {
  return request({
    url: BASE_URL + `/mobile/newcms/statistics/${id}`,
    method: 'get',
  })
}

export function getCommentMore(data) {
  return request({
    url: BASE_URL + '/dx-bridge/get-reply-by-comment-id',
    method: 'post',
    data,
  })
}

//获取用户行为-点赞、收藏数量和状态

export function userBehavior({ applicationId, objectId, objectType }) {
  return request({
    method: 'get',
    url:
      BASE_URL +
      `/dx-bridge/check-like-collect?applicationId=${applicationId}&objectId=${objectId}&objectType=${objectType}`,
  })
}
